import "./views/movie/overview/partials/_rtAudienceReviews.js";
import "./views/movie/overview/partials/_rtCriticReviews.js";
import "./views/movie/reviews/partials/_movieRatingsTabs.js";